var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53.79,48.38c0,2.59-2.1,4.69-4.69,4.69H14.73c-2.59,0-4.69-2.1-4.69-4.69V14.01c0-2.59,2.1-4.69,4.69-4.69 H49.1c2.59,0,4.69,2.1,4.69,4.69V48.38z M49.1,14.59c0-0.32-0.26-0.59-0.59-0.59h-33.2c-0.32,0-0.59,0.26-0.59,0.59v33.2 c0,0.32,0.26,0.59,0.59,0.59h33.2c0.32,0,0.59-0.26,0.59-0.59V14.59z M36.21,43.7h-8.59c-0.65,0-1.17-0.53-1.17-1.17v-2.34 c0-0.65,0.52-1.17,1.17-1.17h1.17v-6.25h-1.17c-0.65,0-1.17-0.53-1.17-1.17v-2.34c0-0.65,0.52-1.17,1.17-1.17h6.25 c0.65,0,1.17,0.52,1.17,1.17v9.77h1.17c0.65,0,1.17,0.52,1.17,1.17v2.34C37.38,43.17,36.86,43.7,36.21,43.7z M36.02,21.82 c0,2.26-1.84,4.1-4.1,4.1s-4.1-1.84-4.1-4.1c0-2.27,1.84-4.1,4.1-4.1S36.02,19.55,36.02,21.82z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.a40891186e393ae1abc7e5a837d45fa9.svg";
export { ForwardRef as ReactComponent };